const map = {
	"./en/auth.json": 3664,
	"./en/bankAccounts.json": 47192,
	"./en/banks.json": 27449,
	"./en/common.json": 46251,
	"./en/contact.json": 14814,
	"./en/contactPage.json": 72757,
	"./en/ebam.json": 34091,
	"./en/entities.json": 6025,
	"./en/errors.json": 25465,
	"./en/help.json": 94985,
	"./en/home.json": 6953,
	"./en/kyc.json": 85079,
	"./en/legal.json": 32883,
	"./en/mandates.json": 78347,
	"./en/nav.json": 45995,
	"./en/privacy.json": 21078,
	"./en/reviews.json": 61915,
	"./en/settings.json": 42815,
	"./en/signatories.json": 82982,
	"./en/terms.json": 41117,
	"./en/users.json": 15158,
	"./en/workflows.json": 59104,
	"./fr/auth.json": 25637,
	"./fr/bankAccounts.json": 38849,
	"./fr/banks.json": 4790,
	"./fr/common.json": 2258,
	"./fr/contact.json": 16669,
	"./fr/contactPage.json": 10654,
	"./fr/ebam.json": 83226,
	"./fr/entities.json": 92916,
	"./fr/errors.json": 73236,
	"./fr/help.json": 83148,
	"./fr/home.json": 38844,
	"./fr/kyc.json": 67996,
	"./fr/legal.json": 8500,
	"./fr/mandates.json": 11022,
	"./fr/nav.json": 14688,
	"./fr/privacy.json": 8613,
	"./fr/reviews.json": 89156,
	"./fr/settings.json": 86150,
	"./fr/signatories.json": 77597,
	"./fr/terms.json": 3134,
	"./fr/users.json": 16841,
	"./fr/workflows.json": 93511
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	const id = map[req];
	return __webpack_require__.t(id, 3 | 16);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 96353;
module.exports = webpackAsyncContext;